export const NOTIFICATION_CENTER_VISIBILITY = Object.freeze({
  MINE: "mine",
  ALL: "all",
});

export const NOTIFICATION_CENTER_DEADLINES_SCOPE = Object.freeze({
  NEXT_3_DAYS: "next_3_days",
  FORTHCOMING: "forthcoming",
  ALL: "all",
  MISSED: "missed",
});
